import { authFetch } from "./auth/authFetch.js";

let apiBaseUrl = "";

export async function loadConfig() {
  const r = await fetch("/config.json");
  if (!r.ok) throw new Error("config.json not found");
  const cfg = await r.json();
  apiBaseUrl = (cfg.apiBaseUrl || "").replace(/\/$/, "");
  return apiBaseUrl;
}

export function getApiBaseUrl() {
  return apiBaseUrl;
}

export async function fetchServices() {
  const r = await authFetch(`${apiBaseUrl}/services`);
  if (!r.ok) throw new Error(await r.text());
  return r.json();
}

export async function fetchRuns(serviceName, { limit = 50, lastKey } = {}) {
  const q = new URLSearchParams({ limit: String(limit) });
  if (lastKey) q.set("last_key", lastKey);
  const r = await authFetch(
    `${apiBaseUrl}/services/${encodeURIComponent(serviceName)}/runs?${q}`,
  );
  if (!r.ok) throw new Error(await r.text());
  return r.json();
}

export async function fetchRun(runId) {
  const r = await authFetch(`${apiBaseUrl}/runs/${encodeURIComponent(runId)}`);
  if (!r.ok) throw new Error(await r.text());
  return r.json();
}
